export default __webpack_public_path__ + "static/media/diagnostic.6ca751a1.png";